import React, {useState, useRef} from 'react'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Form, Input } from 'antd';

import Layout from '../../components/Layout'
import Button from '../../components/Button'
import ProgressBar from '../../components/ProgressBar';
import Modal from '../../components/Modal'

import constants from '../../config/constants'
import email from '../../assets/images/email.svg'

const Main = styled.div`
  padding-top: 2rem;
`

const MainImg = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  padding-top: 2rem;

  .ant-input {
    color: ${constants.color.dark} !important;
    border: 1px solid ${constants.color.lightDark} !important;
    line-height: 24.3px !important;
    height: 40px !important;
    font-size: 16px !important;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }

    &::placeholder {
      color: ${constants.color.lightDark} !important;
    }
  }

  .ant-form-item-required::before {
    content: '' !important;
    margin-right: 0 !important;
  }

  .ant-form-item-label > label {
    font-family: 'Thonburi';
    color: ${constants.color.mediumDark} !important;
  }

  .ant-form-item-control {

    .ant-form-extra {
      font-size: 12px !important;
    }
  }

  .has-error .ant-form-explain, .has-error .ant-form-split {
    color: ${constants.color.red} !important;
  }
`

const Description = styled.p`
  color: ${constants.color.mediumDark};
`

const FormItem = styled(Form.Item)`
  margin-bottom: 2.5rem;
  margin-top: 1rem;
`

const MainModal = styled.div`
  text-align: center;
  padding: 0 15px;
`

const ModalDetail = styled.p`
  color: ${constants.color.mediumDark};
`

const formItemLayout = {
  labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
  },
  wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
  },
};

const ConfirmEmail = (props) => {

  const { getFieldDecorator } = props.form;
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const ref = useRef(null)

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err && status !== 'error') {
        if(props.form.getFieldValue('email') === 'test@test.com') {
          setOpenModal(!openModal)
        } else {
          props.history.push('/otp-confirm-email')
        }
      }
    });
  };

  const hendelInputEmail = e => {
    const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    const truemoneyRegex = /^([^@\s]+)@((?:truemoney+\.)+[a-z]{2,})$/i;
    const truemoneywalletRegex = /^([^@\s]+)@((?:truemoneywallet+\.)+[a-z]{2,})$/i;
    if(e.target.value) {
      if(!emailRegex.test(e.target.value) || truemoneyRegex.test(e.target.value) || truemoneywalletRegex.test(e.target.value)) {
        setStatus('error');
        setErrorMsg('อีเมล์ไม่ถูกต้อง');
      } else {
        setStatus(null);
        setErrorMsg(null);

      }
    } else {
      setStatus('error');
      setErrorMsg('กรุณากรอกอีเมล์');
    }
  }

  const scrollToRef = (ref) => {
    setTimeout(() => {
      window.scrollTo({
        top: ref.current.offsetTop - 80,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }

  return (
    <Layout title={'ข้อมูลส่วนตัว'} backIcon={true} onClick={() => props.history.goBack()}>
      <ProgressBar percent={25}/>
      <Main>
        <MainImg>
          <LazyLoadImage
            alt=''
            height={150}
            visibleByDefault={true}
            src={email}
            width={150} />
        </MainImg>
        <MainDetail>
          <h4>ยืนยันอีเมล</h4>
          <Description>ระบบจะส่งรหัสตัวเลข 8 หลักไปยังอีเมลของคุณ</Description>
          <Form {...formItemLayout} hideRequiredMark={true}>
            <div ref={ref}>
              <FormItem label={'อีเมล์'} validateStatus={status} help={errorMsg}>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      type: 'email',
                      message: 'อีเมล์ไม่ถูกต้อง',
                    },
                    {
                      required: true,
                      message: 'กรุณากรอกอีเมล์',
                    }
                  ],
                  })(<Input placeholder="กรอกอีเมล์" onChange={hendelInputEmail} onClick={()=> scrollToRef(ref)} />)}
              </FormItem>
            </div>
          </Form>
        </MainDetail>
        <Button
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ยืนยัน'}
          disabled={false}
          onClick={handleSubmit}
          />
      </Main>
      <Modal visible={openModal}>
        <MainModal>
          <h4>อีเมล์นี้มีอยู่ในระบบแล้ว</h4>
          <ModalDetail>กรุณากรอกอีเมลใหม่ที่ไม่เคยใช้ลงทะเบียน</ModalDetail>
          <Button
            textcolor={constants.color.white}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ตกลง'}
            disabled={false}
            onClick={() => setOpenModal(!openModal)}/>
        </MainModal>
      </Modal>
    </Layout>
  )
}

const WrappedConfirmEmail = Form.create({ name: 'otherTitle' })(ConfirmEmail);

export default WrappedConfirmEmail
